module.exports = __webpack_public_path__ + "img/logo-golstore.4570ca61.png";